document.addEventListener('DOMContentLoaded', function () {
  var _mq$addEventListener;
  var wrapper = document.querySelector('.header-wrapper');
  if (!wrapper) return;
  var headerEl = wrapper.querySelector('header.header');
  if (!headerEl) return;
  var THRESHOLD = 20; // px
  var appliedColorClass = null; // the color-* we add/remove on .header-wrapper
  var COLOR_PREFIX = 'color-'; // change to 'color-scheme-' if needed

  function getHeaderColorClass() {
    // Find first class in <header> that starts with COLOR_PREFIX
    for (var i = 0; i < headerEl.classList.length; i++) {
      var cls = headerEl.classList[i];
      if (cls.indexOf(COLOR_PREFIX) === 0) return cls;
    }
    return null;
  }
  function syncSticky(active) {
    wrapper.classList.toggle('sticky-active', active);
    if (active) {
      var current = getHeaderColorClass();

      // If we had applied one and it changed, remove old first
      if (appliedColorClass && appliedColorClass !== current) {
        wrapper.classList.remove(appliedColorClass);
        appliedColorClass = null;
      }

      // Add current header color-* to wrapper while active
      if (current && !wrapper.classList.contains(current)) {
        wrapper.classList.add(current);
        appliedColorClass = current;
      }
    } else {
      // When going back to top, remove ONLY what we added
      if (appliedColorClass) {
        wrapper.classList.remove(appliedColorClass);
        appliedColorClass = null;
      }
    }
  }
  function onScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    syncSticky(y > THRESHOLD);
  }
  onScroll(); // initial state
  window.addEventListener('scroll', onScroll, {
    passive: true
  });
  function setupDesktopHeaderHover() {
    var isDesktopHover = window.matchMedia('(min-width: 990px)').matches && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!isDesktopHover) return;
    var detailsList = document.querySelectorAll('header .header__inline-menu details');
    if (detailsList.length === 0) {
      detailsList = document.querySelectorAll('header details:not(header-drawer details):not(menu-drawer details)');
    }
    detailsList.forEach(function (det) {
      if (det.dataset.hoverBound === '1') return;
      det.dataset.hoverBound = '1';
      var sumEl = det.querySelector('summary');
      if (!sumEl) return;
      var closeTimer;
      var open = function open() {
        clearTimeout(closeTimer);
        if (!det.hasAttribute('open')) {
          var _det$closest;
          det.setAttribute('open', '');
          sumEl.setAttribute('aria-expanded', 'true');
          det.classList.add('menu-opening');
          (_det$closest = det.closest('.has-submenu')) === null || _det$closest === void 0 || _det$closest.classList.add('submenu-open');
        }
      };
      var close = function close() {
        var _det$closest2;
        det.classList.remove('menu-opening');
        sumEl.setAttribute('aria-expanded', 'false');
        det.removeAttribute('open');
        (_det$closest2 = det.closest('.submenu-open')) === null || _det$closest2 === void 0 || _det$closest2.classList.remove('submenu-open');
      };
      det.addEventListener('mouseenter', open);
      det.addEventListener('mouseleave', function () {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(close, 140);
      });
      sumEl.addEventListener('click', function (e) {
        return e.preventDefault();
      }, true);
      sumEl.addEventListener('mousedown', function (e) {
        return e.preventDefault();
      }, true);
    });
  }
  setupDesktopHeaderHover();
  var mq = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  (_mq$addEventListener = mq.addEventListener) === null || _mq$addEventListener === void 0 || _mq$addEventListener.call(mq, 'change', setupDesktopHeaderHover);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('header')) setupDesktopHeaderHover();
  });
});